module.exports = __webpack_public_path__ + "img/logos.40f2b8a8.svg";